import React from 'react';
import { Table, Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import profileImg from "../../../common/images/userPrfImg-rmbg.png";

export const CameraDetailModal = ({ show, onHide, resultdata }) => {
  let streamingUrl = resultdata?.streamingUrl;  
  let ipArdessTxt = "";
  let portValTxt = "";
  /*if(streamingUrl) {
      let streamingUrlArr = '';
      const url = new URL(streamingUrl);
            ipArdessTxt = url.hostname;
            portValTxt = url.port || '554'; 
  }*/
  let bunkInchargesArr = resultdata?.bunkIncharges;
  
  let entitiesArr = resultdata?.entities;
  let userRole = resultdata?.roleKey;
  if(entitiesArr) {
      console.log('entitiesArr1', entitiesArr[0].name);
  }

  if(userRole === 'employee') {
      userRole = 'Employee';
  }

  if(userRole === 'bunk_incharge') {
      userRole = 'Bunk Incharge';
  }

  return (
    <Modal role="dialog" className='view-detail-popup cameraview-detail-popup' dialogClassName="right-slide-modal" size='lg' show={show} backdrop centered={false} >
      <div className="modal-content">
        <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
        <ModalHeader>Camera Details</ModalHeader>
        <ModalBody>
          <div className="model-bodey-maindiv">
              
              <div className='camerabasic-info-main'>
                    <h6 className='modalview-info-title'>Camera Information</h6>
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-row'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Camera Name</div>
                                  <div className='modalview-info-val'>
                                    {resultdata.name} {' '}
                                    {resultdata.category === 'in' && (
                                    <span className="camera-in-cls">IN Camera</span>
                                    )}
                                    {resultdata.category === 'out' && (
                                    <span className="camera-out-cls">OUT Camera</span>
                                    )}
                                    </div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Model</div>
                                  <div className='modalview-info-val'>{resultdata.model}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Status</div>
                                  <div className='modalview-info-val'>{(resultdata.isActive==true) ? <span className='status-active-cls'>ACTIVE</span> : <span className='status-inactive-cls'>INACTIVE</span>}</div>
                            </div>
                      </div>
                      <div className='modalview-info-row mt-3'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Manufacturer</div>
                                  <div className='modalview-info-val'>{resultdata.manufacturer}</div>
                            </div>
                      </div>
                    </div>
              </div>

              <div className='cameranetwork-info-main'>
                    <h6 className='modalview-info-title'>Network Details</h6>
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-flx-row'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Stream URL / RTSP</div>
                                  <div className='modalview-info-val link-txt-cls'>{resultdata.streamingUrl}</div>
                            </div>
                            {/* <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>IP Address</div>
                                  <div className='modalview-info-val link-txt-cls'>{ipArdessTxt}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Port</div>
                                  <div className='modalview-info-val link-txt-cls'>{portValTxt}</div>
                            </div> */}
                      </div>
                    </div>
              </div>

              <div className='assignment-info-main'>
                    <h6 className='modalview-info-title'>Assignment Information</h6>
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-row-snglcol'>   
                          <div className='modalview-info-col'>
                                <div className='modalview-info-lable'>Bunk Name</div>
                                <div className='modalview-info-val'>{resultdata?.entityName}</div>
                          </div>
                      </div>
                      <div className='modalview-info-row-snglcol mt-3'>   
                          <div className='modalview-info-col'>
                                <div className='modalview-info-lable'>Bunk Location</div>
                                <div className='modalview-info-val'>{resultdata?.entityAddress1}, {resultdata?.entityAddress2}, {resultdata?.entityDistrict}, {resultdata?.entityState} - {resultdata?.entityPincode}</div>
                          </div>
                      </div>  
                      {(bunkInchargesArr) && <div className='modalview-info-row mt-3'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Bunk Incharge</div>
                                  <div className='modalview-info-val'>
                                    {bunkInchargesArr[0].firstName} {' '} {bunkInchargesArr[0].lastName}
                                  </div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Contact Number</div>
                                  <div className='modalview-info-val'>{bunkInchargesArr[0].phone}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Email</div>
                                  <div className='modalview-info-val'>{bunkInchargesArr[0].email}</div>
                            </div>
                      </div>}
                    </div>
              </div>

          </div>    
        </ModalBody>
      </div>
    </Modal>
  );
};

